var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconEvaluate48Filled = function SvgIconEvaluate48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8 28.3h-2.1V13.6c0-2.92-2.38-5.3-5.3-5.3H13.6a5.31 5.31 0 0 0-5.3 5.3v21.9a4.2 4.2 0 0 0 4.2 4.2h23c.12 0 .23-.01.34-.03 2.15-.18 3.86-1.97 3.86-4.17v-4.3c0-1.6-1.3-2.9-2.9-2.9Zm-15.46.48c-.43.43-1.02.67-1.62.67h-.05c-.62-.01-1.22-.28-1.64-.74l-3.78-4.08 2.49-2.31 3.01 3.25 6.55-6.52 2.4 2.41-7.35 7.32h-.01Zm14.95 6.72c0 .44-.36.8-.8.8-.44 0-.8-.36-.8-.8v-3.8h1.6v3.8Z",
    fill: "current"
  })));
};
export default SvgIconEvaluate48Filled;